module.exports = __webpack_public_path__ + "img/wink-logo-wh.77ad6ee4.svg";